// extracted by mini-css-extract-plugin
export var linkText = "_pg-0";